export enum SfRoutesEnum {
  'notFound' = 'not-found',
  'forbidden' = 'forbidden',
  'error' = 'error',
}
